export const toCamelCase = (str: string): string => {
    return str
      .split(" ")
      .map(word => word ? word.charAt(0).toUpperCase() + word.slice(1).toLowerCase() : "")
      .join(" ");
  };
